<div class="card-menu-item"
	 (click)="item().onClick()"
	 [ngClass]="{ 'active': item().activePredicate(), 'greyed-out': !!item().hiddenPredicate && item().hiddenPredicate() }"
	 (mouseenter)="!!item().onHoverOn && item().onHoverOn()"
	 (mouseleave)="!!item().onHoverOff && item().onHoverOff()"
>
	<div class="card-header">
		<div class="card-header-title"
         [ngClass]="{ 'greyed-out': !!item().hiddenPredicate && item().hiddenPredicate() }"
    >
			{{ item().title }}
		</div>
		<div class="card-header-action">
			@if (item().subMenus?.length === 1) {
				<button
						class="ami-action-button button-on-hover"
						(click)="item().subMenus[0].onClick();$event.stopPropagation()"
						mat-icon-button
						[matTooltip]="item().subMenus[0].label"
				>
					<mat-icon class="ami-action-icon">{{ item().subMenus[0].icon }}</mat-icon>
				</button>
			}
			@if (!!item().actionIcon && item().actionIcon.startsWith('pinned_')) {
				<!-- not pinned -->
				@if (!!item().actionIcon && item().actionIcon.endsWith('_false')) {
					<button
							class="ami-action-button button-on-hover"
							mat-icon-button
							(click)="item().inactivePredicate()"
							[matTooltip]="'Pin'"
					>
						<mat-icon class="ami-action-icon">keep</mat-icon>
					</button>
				}
				<!-- pinned -->
				@if (!!item().actionIcon && item().actionIcon.endsWith('_true')) {
					<button
							class="ami-action-button black"
							mat-icon-button
							(click)="item().inactivePredicate()"
							[matTooltip]="'Unpin'"
					>
						<mat-icon class="ami-action-icon">keep</mat-icon>
					</button>
				}
			}
			@if (!!item().subMenus && item().subMenus.length > 1) {
				<button
						class="ami-action-button"
						[matMenuTriggerFor]="menu"
						(click)="$event.stopPropagation()"
						mat-icon-button
				>
					<mat-icon class="ami-action-icon">more_vert</mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					@for (subMenu of item().subMenus; track $index) {
						<button mat-menu-item (click)="subMenu.onClick();$event.stopPropagation()">
							<mat-icon>{{ subMenu.icon }}</mat-icon>
							<span>{{ subMenu.label }}</span>
						</button>
					}
				</mat-menu>
			}
		</div>
	</div>

	<div class="card-body">{{ item().subtitle }}</div>

	<div class="card-footer">
		<div>
			{{ item().text3 }}
		</div>
		@if (!!item().actionIcon && item().icon === 'message') {
			<div class="card-footer-right">
				{{ item().actionIcon }}
				<mat-icon>visibility</mat-icon>
			</div>
		}
	</div>

</div>
